import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';

const CustomTableHeader = ({children}) => {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: "inherit",
          color: "gray", fontSize: 14
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 14,
        },
    }));

    return (
          <StyledTableCell key={children}>{children}</StyledTableCell>
    )
}

export default CustomTableHeader;